const getRecaptchaStrategy = state => state.recaptcha.recaptchaStrategy;

export default getRecaptchaStrategy;
